import { ReactNode, createContext, useContext } from 'react';

/**
 * Holds the id of the trader an admin is currently "viewing as". When set, the
 * dashboard's data hooks (accounts, balance, stats) fetch this user's data from
 * the `/admin/*` endpoints instead of the authenticated admin's `/me/*` data.
 *
 * `null` (the default when no provider is present) means "use the logged-in
 * user", which preserves the normal end-user dashboard behavior.
 */
const ImpersonatedUserContext = createContext<number | null>(null);

export const ImpersonatedUserProvider = ({
  userId,
  children,
}: {
  userId: number | null;
  children: ReactNode;
}) => (
  <ImpersonatedUserContext.Provider value={userId}>{children}</ImpersonatedUserContext.Provider>
);

/**
 * Returns the impersonated trader's id, or `null` when not viewing as another
 * user. Data hooks branch on this to choose between `/admin/*` and `/me/*`.
 */
export const useImpersonatedUserId = (): number | null => useContext(ImpersonatedUserContext);
